import * as validation from 'shared/utils/validation';
import shortUrl from 'services/iclinic/shortUrl';

export default {
  validation,
  shortUrl,
};
